import { useCallback, useContext } from 'react';
import MatomoContext from './MatomoContext';
import useOutboundClickListener from './utils/useOutboundClickListener';

function useMatomo() {
  var instance = useContext(MatomoContext);
  var trackPageView = useCallback(function (params) {
    return instance === null || instance === void 0 ? void 0 : instance.trackPageView(params);
  }, [instance]);
  var trackEvent = useCallback(function (params) {
    return instance === null || instance === void 0 ? void 0 : instance.trackEvent(params);
  }, [instance]);
  var trackEvents = useCallback(function () {
    return instance === null || instance === void 0 ? void 0 : instance.trackEvents();
  }, [instance]);
  var trackSiteSearch = useCallback(function (params) {
    return instance === null || instance === void 0 ? void 0 : instance.trackSiteSearch(params);
  }, [instance]);
  var trackLink = useCallback(function (params) {
    return instance === null || instance === void 0 ? void 0 : instance.trackLink(params);
  }, [instance]);
  var enableLinkTracking = useCallback(function () {
    if (instance) {
      useOutboundClickListener(instance);
    }
  }, [instance]);
  var pushInstruction = useCallback(function (name) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    instance === null || instance === void 0 ? void 0 : instance.pushInstruction.apply(instance, [name].concat(args));
  }, [instance]);
  return {
    trackEvent: trackEvent,
    trackEvents: trackEvents,
    trackPageView: trackPageView,
    trackSiteSearch: trackSiteSearch,
    trackLink: trackLink,
    enableLinkTracking: enableLinkTracking,
    pushInstruction: pushInstruction
  };
}

export default useMatomo;